import { useContext, useEffect, useState } from 'react';
import { useNavigate } from 'react-router-dom';

import AlertFeed from "../../Global/Views/FeedViewer/AlertFeed";
import { AuthContext } from '../../Controllers/context/auth';
import { BlankSpacer, ViewModule } from "../../Global/StyledComponents/AppStyledComponents";
import Chart from './components/Chart';
import Drawer from '../../Global/Components/Drawer';
import ExpandedView from '../../Global/Components/ExpandedView/ExpandedView';
import FeedViewer from "../../Global/Views/FeedViewer/FeedViewer";
import { Input, SearchArea } from '../../Global/StyledComponents/UserFormStyledComponents';
import Loading from '../../Global/Components/LoadingSpinner';
import MacroSummariesFeed from '../../Global/Views/FeedViewer/MacroSummariesFeed';
import MacroMovers from '../../Global/Views/FeedViewer/MacroMovers';
import SearchDropdown from '../../Global/Components/SearchDropdown';
import { StateContext } from '../../Controllers/context/state';
import TVChartContainer from '../../Global/Components/TradingViewChart';
import { useParams } from 'react-router-dom';

const AssetMonitor = () => {
    const [dateDisplay, setDateDisplay] = useState(new Date().toISOString().split('T')[0]);
    const [selectedDate, setSelectedDate] = useState(new Date().getTime()/1000);
    const params = useParams();
    const symbol = params.symbol + (params['*'] ? `/${params['*']}` : '');
    const [startingWidth, setStartingWidth] = useState();
    const {
        assets,
        development,
        fullNameKey,
        isLoading,
        logError,
        newAlerts,
        setExpandedViewTicker,
    } = useContext(StateContext);
    const navigate = useNavigate();
    const { session } = useContext(AuthContext);
    const [width, setWidth] = useState();

    const handleDateChange = (e) => {
        setSelectedDate(new Date(e.target.value).getTime()/1000);
        setDateDisplay(e.target.value);
    };

    const handleSearchSubmit = (value) => {
        navigate(`/ticker/${value}`);
    };


    useEffect(() => {
        setWidth(window.innerWidth - 514);
        setStartingWidth(window.innerWidth - 514);
    }, [symbol])

    useEffect(() => {
        setExpandedViewTicker(symbol);
    }, [symbol]);

    if (isLoading) {
        return (
            <ViewModule>
                <Loading />
            </ViewModule>
        );
    }

    return (
        <>
            {development ?
                <ViewModule>
                        <div style={{ display: 'flex'}}>
                            <div style={{ marginRight: '10px'}}>
                                <TVChartContainer height='75vh' symbol={fullNameKey?.[symbol.toUpperCase()]} width={width}/>
                            </div>
                            <div style={{ height: '75vh', width: '400px'}}>
                                <ExpandedView assetPage />
                            </div>
                        </div>
                </ViewModule> :
                <ViewModule>
                    <div style={{ display: 'flex', width: width, justifyContent: 'space-between' }}>
                        <SearchArea>
                            <SearchDropdown
                                handleSubmit={handleSearchSubmit}
                                options={assets}
                                position='right'
                            />
                        </SearchArea>
                        <Input
                            min={new Date('15 February, 2023').toISOString().split('T')[0]}
                            max={new Date().toISOString().split('T')[0]}
                            onChange={handleDateChange}
                            style={{ marginRight: 0 }}
                            type='date'
                            value={dateDisplay}
                        />
                    </div>
                    <BlankSpacer/>
                    <div style={{ display: 'flex'}}>
                        <div style={{ marginRight: '10px'}}>
                            {session &&
                                <Chart
                                    logError={logError}
                                    session={session}
                                    ticker={symbol.toUpperCase()}
                                    time_utc={selectedDate} width={width}
                                />
                            }
                        </div>
                        <div style={{ height: '75vh', width: '400px'}}>
                            <ExpandedView assetPage />
                        </div>
                    </div>
                </ViewModule>
            }
            <Drawer rotate={'true'} setWidth={setWidth} startingWidth={startingWidth}>
                <FeedViewer title='News Feed'/>
                {development &&
                    <MacroMovers title='Macro Movers'/>
                }
                {/* <AlertFeed id='alerts' number={newAlerts} title='Watchlist Alerts'/> */}
                <MacroSummariesFeed title="Macro Overview" />
            </Drawer>
        </>
    );
};

export default AssetMonitor;